/**
 * @name: exportSchemeTypes
 * @description: 导出方案配置弹窗共用的类型定义
 */

/** 方案字段配置项，结构与 getComponentByPageCode 返回项一致，save/update 时原样回传 */
export interface SchemeField {
  code: string;
  name: string;
  /** 是否导出 */
  inTemplate: boolean;
  componentType?: string;
  config?: string;
  source?: string;
  /** 子表所属字段名称；source=sub 时用于展示前缀 */
  sourceName?: string;
  [k: string]: any;
}

/**
 * 方案内字段身份：主表/子表可出现相同字段编码（如税额 taxAmount），
 * 勾选比对、同步勾选、列表行 key 均须用此键，不能只用 code。
 */
export const getSchemeFieldIdentity = (
  field: Pick<SchemeField, 'code' | 'source' | 'sourceName'>,
): string => `${field.source || ''}::${field.sourceName || ''}::${field.code}`;

export interface SchemeItem {
  id: string;
  name: string;
  /** 是否全局应用：关闭时仅创建者自己可见/可用，开启后对所有人可见/可用 */
  globalApply: boolean;
  /** 方案创建人用户 id；已落库且缺省时按无创建人旧方案处理 */
  createUser?: string;
  fields: SchemeField[];
  /** 本地草稿：悬浮框确定后仅在前端展示，右下角保存时才调用 save 落库 */
  isDraft?: boolean;
}
